export default __webpack_public_path__ + "static/media/inactiveBox.28a1a844.svg";